import { Tag, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleBar from 'simplebar-react';

interface Service {
  id?: number;
  serviceId?: number;
  name: string;
}

interface ServicesDisplayProps {
  services: Service[];
  maxVisible?: number;
}

export const ServicesDisplay: React.FC<ServicesDisplayProps> = ({ services, maxVisible = 2 }) => {
  const { t } = useTranslation();

  if (!services || services.length === 0) {
    return <span>-</span>;
  }

  const visibleServices = services.slice(0, maxVisible);
  const hiddenServices = services.slice(maxVisible);

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
      }}
    >
      {visibleServices.map((service) => (
        <Tag key={`${Math.random().toString()}-${service.id}`} style={{ marginBottom: 2 }}>
          {service.name}
        </Tag>
      ))}
      {hiddenServices.length > 0 && (
        <Tooltip
          title={
            <SimpleBar className="services-tooltip-scroll" style={{ maxHeight: 300, width: 260 }}>
              <ul className="list-disc pl-5 pr-5 py-2 text-white marker:text-white break-words whitespace-normal">
                {hiddenServices.map((service, index) => (
                  <li key={service.id || service.serviceId || index} className="text-sm text-white">
                    {service.name}
                  </li>
                ))}
              </ul>
            </SimpleBar>
          }
        >
          <Tag style={{ marginBottom: 2, cursor: 'pointer' }}>
            {t('common-more-count', { count: hiddenServices.length })}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
};
